var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPaperAirplane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7148 40.1429L19.1434 60.7143L76.1434 20L15.7148 40.1429Z",
    fill: "#1150AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1426 60.7143L22.5711 43.5714L40.9997 46.5714L19.1426 60.7143Z",
    fill: "#0B3E91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0758 48.4641L25.2738 56.7477L22.5723 43.5714L38.0758 48.4641Z",
    fill: "#0B3E91"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.85742 34.1429L76.1431 20L49.1431 56.4286L22.5717 43.5714L76.1431 20L15.7146 40.1429L2.85742 34.1429Z",
    fill: "#ADCCF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaperAirplane);
export default __webpack_public_path__ + "static/media/icon-paper-airplane.034457ffddd1ff70cf050936a9a78ad6.svg";
export { ForwardRef as ReactComponent };